import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import {
  setIsRepositioningProfileHero,
  setProfileHeroDeviation,
  saveProfileHero,
  deleteProfileHero,
} from '../../../../actions/profileHeroEditor';
import {
  FirstTimeFlag,
  dropFirstTimeFlag,
} from '@wix/da-shared-react/pkg/redux/firstTimeFlags';
import { getCoverDeviation } from '../../../../selectors/deviations';
import { getIsRepositioningProfileHero } from '../../../../selectors/profileHeroEditor';
import { Props } from './ProfileHeroEditControls';

export type StateProps = Pick<
  Props,
  'coverDeviation' | 'isRepositioning' | 'showWatchIntro'
>;
export type DispatchProps = Pick<
  Props,
  | 'setIsRepositioningProfileHero'
  | 'setProfileHeroDeviation'
  | 'saveProfileHero'
  | 'deleteProfileHero'
  | 'dropProfileEditAidFlag'
>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  ownProps
) => {
  const coverDeviation = getCoverDeviation(state);
  const showWatchIntro =
    !ownProps.showProfileHeroAid && ownProps.showProfileEditAid;

  return {
    coverDeviation,
    isRepositioning: getIsRepositioningProfileHero(state),
    showWatchIntro,
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  setIsRepositioningProfileHero,
  setProfileHeroDeviation,
  saveProfileHero,
  deleteProfileHero,
  dropProfileEditAidFlag: () =>
    dropFirstTimeFlag({ flag: FirstTimeFlag.ProfileEditAidNotClosed }),
};

export default connect(mapStateToProps, mapDispatchToProps);
